/* global System */

export default {
  FloatingMenu: () =>
    System.import(/* webpackChunkName: "FloatingMenu" */ './index'),
}
